export default {
    name: "date_now",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Today',
                "args0": [
                ],
                "inputsInline": true,
                "output": "Date",
                "colour": 4.5,
                "tooltip": "Returns today",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        return [`Java.type("java.time.LocalDate").now()`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}